export function isCombinedNamesUnderLimit(maxLength: number, currentValue: string, otherValue: string) {
  // This function is used during checkout to ensure first name + last name length
  // is within the limit imposed by shipping carriers
  const currentValueWithoutPrefix = (currentValue || '').toString()
  const otherValueString = (otherValue || '').toString()
  const combinedLength = currentValueWithoutPrefix.length + otherValueString.length

  return combinedLength <= maxLength
}
